import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Cancel } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { IconTooltipButton } from '@/components/iconTooltipButton/IconTooltipButton';

import { styles } from './UploadImage.styles';

type TUploadImageSelectedProps = {
  file: File;
  clear: () => void;
};

export const UploadImageSelected = ({ file, clear }: TUploadImageSelectedProps) => {
  const { t } = useTranslation();
  const fileUrl = useMemo(() => URL.createObjectURL(file), [file]);

  useEffect(() => {
    return () => URL.revokeObjectURL(fileUrl);
  }, [fileUrl]);

  return (
    <>
      <Box sx={styles.selectedImage}>
        <img alt={file.name} src={fileUrl as string} />

        <IconTooltipButton
          label={t('uploadImage.removeImage')}
          size="small"
          onClick={clear}
          sx={styles.clearImage}
          disableRipple
        >
          <Cancel />
        </IconTooltipButton>
      </Box>

      <Typography variant="body2">{file.name}</Typography>
    </>
  );
};
